module.exports = __webpack_public_path__ + "static/img/tupian_pt.ebc4dd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tupian_pt.png
// module id = L8ce
// module chunks = 10